import React, { useEffect, useState } from "react";
import { useFieldArray, useForm, useWatch } from "react-hook-form";
import { TextInput, SubmitBar, FormStep, RadioButtons, CardLabel, RadioOrSelect, Card } from "@egovernments/digit-ui-react-components";
import Grid from '@mui/material/Grid';
import { Box, IconButton } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';

const InputText = React.forwardRef(({ label, register, required, name, t, placeholder, grid = 6, disabled = false }, ref) => (
  <Grid item xs={grid}>
    <CardLabel>{`${t(label)}`}</CardLabel>
    <TextInput
      t={t}
      type={"text"}
      optionKey="i18nKey"
      name={name}
      placeholder={placeholder}
      {...register(name)}
      disabled={disabled}
      required={required}
      inputRef={ref}
    />
  </Grid>
));
const Select = React.forwardRef(({ onChange, name, label, t, options, selectedOption, isDropDown = false, sortOptions = true }, ref) => (
  <Grid item xs={6}>
    <span className={"form-pt-dropdown-only"}>
      <CardLabel>{t(label)}</CardLabel>
      <RadioOrSelect
        optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
        options={sortOptions ? options.sort((a, b) => a.name.localeCompare(b.name)) : options}
        optionKey="name"
        selected={selectedOption}
        _ref={ref}
        name={name}
        onSelect={onChange}
        t={t}
        isDropDown={isDropDown}
        isDependent={true}
      />
    </span>
  </Grid>

))
const useTypeList = [
  {
    code: "hp.tcpsolan",
    id: 1,
    name: "Residential"
  },
  {
    code: "hp.tcpsolan",
    id: 2,
    name: "Commercial"
  },
  {
    code: "hp.tcpsolan",
    id: 3,
    name: "Industrial"
  },
  // {
  //   code: "hp.tcpsolan",
  //   id: 4,
  //   name: "Public"
  // }
]
const typeOfLandVolvedYesList = [
  {
    code: "hp.tcpsolan",
    id: 1,
    name: "For change of Land use from the original Use"
  },
  {
    code: "hp.tcpsolan",
    id: 2,
    name: "IDP/Development Plan to Other Land Use"
  }
]
const propertyTypeList = [
  {
    code: "hp.tcpsolan",
    id: 1,
    name: "Govt"
  },
  {
    code: "hp.tcpsolan",
    id: 2,
    name: "Private"
  },
  {
    code: "hp.tcpsolan",
    id: 3,
    name: "Public & Semi Public"
  }
]
const typeOfLandVolvedList = [
  {
    active: true,
    code: "YES",
    name: "Yes",
    i18nKey: "COMMON_MASTERS_YES"
  },
  {
    active: true,
    code: "NO",
    name: "No",
    i18nKey: "COMMON_MASTERS_NO"
  }
]

const DescriptionOfLand = ({ t, onSelect, formData, currStep }) => {
  const khasraTableEntry = { plotNo: 0, plotArea: 0, typeOfLand: null };
  const khasraWithAreaEntry = { khasraNo: 0, area: 0 };
  const defaultValues = {
    revenueVillageMohal: formData[currStep.key]?.revenueVillageMohal || null,
    khataNo: formData[currStep.key]?.khataNo,
    khatauniNo: formData[currStep.key]?.khatauniNo,
    latitude: formData[currStep.key]?.latitude,
    longitude: formData[currStep.key]?.longitude,
    khasraWithArea: formData[currStep.key]?.khasraWithArea || [khasraWithAreaEntry],
    totalPlotArea: formData[currStep.key]?.totalPlotArea || '',
    noOfPlot: formData[currStep.key]?.noOfPlot,
    propertyType: formData[currStep.key]?.propertyType || null,
    useType: formData[currStep.key]?.useType || null,
    plotArea: formData[currStep.key]?.plotArea,
    typeOfLandVolved: formData[currStep.key]?.typeOfLandVolved || null,
    typeOfCLUInvolved: formData[currStep.key]?.typeOfCLUInvolved || null,
    khasraTable: formData[currStep.key]?.khasraTable || [khasraTableEntry],
  };

  const {
    watch,
    control,
    register,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues });

  const { fields: khasraWithArea, append, remove } = useFieldArray({
    control,
    name: "khasraWithArea",
  });
  const { fields: khasraTable, append: appendTable, remove: removeTable } = useFieldArray({
    control,
    name: "khasraTable",
  });
  const watchPlotArea = watch("khasraWithArea");
  const watchKhasraTable = watch("khasraTable");
  const khasraWithAreaFields = khasraWithArea.map((field, index) => {
    return {
      ...field,
      ...watchPlotArea[index]
    };
  });
  const khasraTableFields = khasraTable.map((field, index) => {
    return {
      ...field,
      ...watchKhasraTable[index]
    };
  });

  useEffect(() => {
    const total = khasraWithAreaFields.reduce((total, field) => {
      return total + Number(field.area);
    }, 0);

    setValue('totalPlotArea', Number(total));
  }, [khasraWithAreaFields]);

  // useEffect(() => {
  //   console.log('Form 11 test khasraTableFields', khasraTableFields);
  // }, [khasraTableFields]);

  const [useType, setUseType] = useState(formData[currStep.key]?.useType || null);
  const [propertyType, setPropertyType] = useState(formData[currStep.key]?.propertyType || null);
  const [typeOfLandVolved, setTypeOfLandVolved] = useState(formData[currStep.key]?.typeOfLandVolved || null);
  const [typeOfCLUInvolved, setTypeOfCLUInvolved] = useState(formData[currStep.key]?.typeOfCLUInvolved || null);

  function selectedValue(value) {
    setTypeOfLandVolved(value);
    setValue('typeOfLandVolved', value);
  }
  function selectedValueUseType(value) {
    setUseType(value);
    setValue('useType', value);
  }
  function selectedValuePropertyType(value) {
    setPropertyType(value);
    setValue('propertyType', value);
  }
  function selectTypeOfCLUInvolved(value) {
    setTypeOfCLUInvolved(value);
    setValue('typeOfCLUInvolved', value);
  }

  const onSkip = () => onSelect();
  const handleOnSubmit = (descriptionOfLand) => {

    onSelect(currStep.key, descriptionOfLand);
  }

  return (
    <div>
      <FormStep
        cardStyle={{ boxShadow: 'none', padding: 0, border: 0, overflowY: 'auto' }}
        _defaultValues={formData?.data}
        childrenAtTheBottom={false}
        onSelect={handleSubmit(handleOnSubmit)}
        onSkip={onSkip}
        t={t}
      >
        <div>
          <Grid container spacing={2}>
            <InputText
              {...{
                label: "BPA_DOL_REVENUE_VILLAGE_MOHALLA_LABEL",
                register,
                required: false,
                name: "revenueVillageMohal",
                t,
                placeholder: "Enter Revenue Village Mohalla"
              }}
            />

            <InputText
              {...{
                label: "BPA_DOL_KHATA_NO_LABEL",
                register,
                required: false,
                name: "khataNo",
                t,
                placeholder: "Enter khata No"
              }}
            />

            <InputText
              {...{
                label: "BPA_DOL_KHATAUNI_NO_LABEL",
                register,
                required: false,
                name: "khatauniNo",
                t,
                placeholder: "Enter khatauni No"
              }}
            />

            <Grid item xs={6} container spacing={2}>
              <InputText
                {...{
                  label: "BPA_DOL_LATITUDE_LABEL",
                  register,
                  required: false,
                  name: "latitude",
                  t,
                  placeholder: "Enter latitude"
                }}
              />

              <InputText
                {...{
                  label: "BPA_DOL_LONGITUDE_LABEL",
                  register,
                  required: false,
                  name: "longitude",
                  t,
                  placeholder: "Enter longitude"
                }}
              />
            </Grid>

            {khasraWithAreaFields.map((field, index) => {
              return (
                <Grid item container key={field.id} spacing={2}>
                  <Grid item xs={6}>
                    <CardLabel>{`${t("BPA_DOL_KHASARA_NO_LABEL")}`}</CardLabel>
                    <TextInput
                      {...register(`khasraWithArea.${index}.khasraNo`)}
                      name={`khasraWithArea.${index}.khasraNo`}
                      t={t}
                      type={"text"}
                      optionKey="i18nKey"
                    />
                  </Grid>
                  <Grid item xs={6} container sx={{ alignItems: 'center' }}>
                    <Box sx={{ flex: 1 }}>
                      <CardLabel>{`${t("BPA_DOL_AREA_SQM_LABEL")}`}</CardLabel>
                      <TextInput
                        {...register(`khasraWithArea.${index}.area`)}
                        name={`khasraWithArea.${index}.area`}
                        t={t}
                        type={"text"}
                        optionKey="i18nKey"
                      />
                    </Box>
                    <Box sx={{ display: 'flex', gap: '.5rem', mt: ".9rem", ml: '.5rem' }}>
                      <IconButton color="primary" aria-label="add" onClick={() => append(khasraWithAreaEntry)}>
                        <AddBoxIcon />
                      </IconButton>
                      {khasraWithArea.length > 1 && (
                        <IconButton color="error" aria-label="delete" onClick={() => remove(index)}>
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              )
            })}

            <InputText
              {...{
                label: "BPA_DOL_TOTAL_PLOT_AREA_LABEL",
                register,
                required: false,
                name: "totalPlotArea",
                t,
                placeholder: "Enter Total Plot Area"
              }}
              disabled
            />

            <InputText
              {...{
                label: "BPA_DOL_NO_OF_PLOT_LABEL",
                register,
                required: false,
                name: "noOfPlot",
                t,
                placeholder: "Enter Number of Plot"
              }}
            />

            <Select
              {...{
                label: "CORE_COMMON_PROPERTY_TYPE",
                register,
                required: false,
                name: "propertyType",
                t,
                selectedOption: propertyType,
                options: propertyTypeList,
                onChange: selectedValuePropertyType
              }}
            />

            <Select
              {...{
                label: "CORE_COMMON_USE_TYPE",
                register,
                required: false,
                name: "useType",
                t,
                selectedOption: useType,
                options: useTypeList,
                onChange: selectedValueUseType
              }}
            />

            <InputText
              {...{
                label: "CORE_COMMON_PLOT_AREA",
                register,
                required: false,
                name: "plotArea",
                t,
                placeholder: "Enter plot Area"
              }}
            />
          </Grid>
          <div>
            <p>
              <h2>
                <CardLabel>{`${t("BPA_DETAILS_OF_PLOT_AFTER_SUBDIVISION")} *`}</CardLabel>
              </h2>
            </p>
            <Card>
              <CardLabel>{`${t("BPA_TYPE_OF_LAND_VOLVED")} *`}</CardLabel>
              <RadioButtons
                style={{ display: 'flex', gap: '3rem', margin: 0 }}
                options={typeOfLandVolvedList}
                selectedOption={typeOfLandVolved}
                optionsKey="i18nKey"
                {...register(`typeOfLandVolved`)}
                name={'typeOfLandVolved'}
                onSelect={selectedValue}
                labelKey="PT_OWNERSHIP"
                isDependent={true}
              />

              {typeOfLandVolved?.code == "YES" && (
                <Select
                  {...{
                    label: "BPA_TYPE_OF_CLU_INVOLVED",
                    register,
                    required: false,
                    name: "typeOfCLUInvolved",
                    t,
                    options: typeOfLandVolvedYesList,
                    onChange: selectTypeOfCLUInvolved
                  }}
                  isDropDown
                />
              )}
              {typeOfLandVolved?.code == "YES" && typeOfCLUInvolved && (
                <div className="table table-bordered table-responsive" style={{ display: "block", overflowX: 'visible' }}>
                  <table>
                    <thead>
                      <tr>
                        <th className="fw-normal" style={{ minWidth: 50 }}>{`${t("BPA_SHORT_SERIAL_NO")}`}</th>
                        <th className="fw-normal">{`${t("BPA_PLOT_NO")} *`}</th>
                        <th className="fw-normal">{`${t("BPA_PLOT_AREA")} *`}</th>
                        <th className="fw-normal">{`${t("BPA_TYPE_OF_LAND_DEVELOPMENT")} *`}</th>
                        <th className="fw-normal">{`${t("BPA_ADD_MORE")}`}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {khasraTableFields.map((field, index) => {
                        return (
                          <tr key={field.id}>
                            <th className="fw-normal" style={{ minWidth: 50 }}>{index + 1}</th>
                            <td>
                              <TextInput
                                {...register(`khasraTable.${index}.plotNo`)}
                                name={`khasraTable.${index}.plotNo`}
                                t={t}
                                style={{ margin: 0 }}
                                type={"text"}
                                optionKey="i18nKey"
                                placeholder={"Enter Khasra No."}
                                disabled={false}
                                required={false}
                              />
                            </td>
                            <td>
                              <TextInput
                                {...register(`khasraTable.${index}.plotArea`)}
                                name={`khasraTable.${index}.plotArea`}
                                t={t}
                                style={{ margin: 0 }}
                                type={"text"}
                                optionKey="i18nKey"
                                placeholder={"Enter Area (sq.m)"}
                                disabled={false}
                                required={false}
                              />
                            </td>
                            <td>
                              <RadioOrSelect
                                {...register(`khasraTable.${index}.typeOfLand`)}
                                name={`khasraTable.${index}.typeOfLand`}
                                dropdownStyle={{ margin: 0 }}
                                optionCardStyles={{ maxHeight: "20vmax", overflow: "scroll" }}
                                options={useTypeList.sort((a, b) => a.name.localeCompare(b.name))}
                                optionKey="name"
                                // selectedValue={value={getValues(`khasraTable.${index}.typeOfLand`)}}
                                onSelect={val => setValue(`khasraTable.${index}.typeOfLand`, val)}
                                t={t}
                                isDependent={true}
                                isDropDown={true}
                              />
                            </td>
                            <td>
                              <Box sx={{ display: 'flex', gap: '.5rem' }}>
                                <IconButton color="primary" aria-label="Add more" onClick={() => appendTable(khasraTableEntry)}>
                                  <AddBoxIcon />
                                </IconButton>
                                {khasraTableFields.length > 1 && (
                                  <IconButton color="error" aria-label="Delete" onClick={() => removeTable(index)}>
                                    <DeleteIcon />
                                  </IconButton>
                                )}
                              </Box>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </Card>
          </div>
        </div>

        <SubmitBar label={t(`CS_COMMON_NEXT`)} onSubmit={handleSubmit(handleOnSubmit)} style={{ marginTop: '1rem' }} />
      </FormStep>
    </div>
  )
};

export default DescriptionOfLand;
